import React from "react";
import { ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { domain } from "../domain";

const themePath = `${domain.baseUrlEnerConnect}/themes`;
const fallbackTheme = `{
  "palette": {
    "mode": "light",
    "primary": {
      "main": "#3f51b5"
    },
    "secondary": {
      "main": "#eceff1",
      "contrastText": "#555555"
    }
  },
  "props": {
  }
}`;

const defaultBreakPoints = {
    values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
    },
};


const fetchTheme = async (themeName) => {
    if (!themeName || themeName === 'undefined') {
        themeName = "default";
    }

    return fetch(`${themePath}/${themeName}.json`)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log("THEME ERROR", error, `${themePath}/${themeName}.json`);
            return fallbackTheme;
        });
}

const getInitialThemeState = () => {
    const themeState = { themeName: domain.theme, themeMode: "light", logo: `${domain.theme}.light.png` };

    const returnUrlQueryParam = new URLSearchParams(window.location.search).get('ReturnUrl');

    if (returnUrlQueryParam !== null && returnUrlQueryParam !== undefined) {
        const userThemePreference = new URLSearchParams(returnUrlQueryParam).get('userThemePreference');

        if (userThemePreference !== null && userThemePreference !== undefined) {
            themeState.themeMode = userThemePreference;
            themeState.logo = `${domain.theme}.${userThemePreference}.png`;
        }
    }

    return themeState;
}

const initialThemeState = getInitialThemeState();

const themeStateReducer = (state, action) => {
    return {
        ...state,
        themeName: action.name,
        themeMode: action.mode,
        logo: action.name + "." + action.mode + ".png"
    };
};

export const UcThemeContext = React.createContext({
    themeState: initialThemeState,
    dispatch: () => null
});

export const UcThemeProvider = ({ children }) => {
    const [loading, setLoading] = React.useState(true);
    const [theme, setTheme] = React.useState(createTheme({
        palette: initialThemeState.palette,
    }));
    const [themeState, themeDispatch] = React.useReducer(themeStateReducer, initialThemeState); // initial state is default loading theme?
    const themeName = `${themeState.themeName}.${themeState.themeMode}`;

    const returnUrlQueryParam = new URLSearchParams(window.location.search).get('ReturnUrl');
    if (returnUrlQueryParam !== null && returnUrlQueryParam !== undefined) {
        const userThemePreference = new URLSearchParams(returnUrlQueryParam).get('userThemePreference');

        if (userThemePreference !== null && userThemePreference !== undefined) {
            if (userThemePreference !== themeState.themeMode) {
                themeDispatch({ name: themeState.themeName, mode: userThemePreference });
            }
        }
    }

    React.useEffect(() => {
        async function fetchThemeLocal() {
            setLoading(true);

            let newTheme = await fetchTheme(themeName);
            if (!newTheme) {
                newTheme = fallbackTheme;
            }

            if (newTheme.palette !== undefined) {
                setTheme(createTheme({
                    palette: newTheme.palette,
                    breakpoints: newTheme.breakpoints??defaultBreakPoints,
                    props: {...newTheme.props},
                }));
            }

            setLoading(false);
        }
        fetchThemeLocal();
    }, [themeState, themeName]);

        return (
            <>
                {!loading &&
                    <UcThemeContext.Provider value={[themeState, themeDispatch]}>
                        <ThemeProvider theme={theme}>
                            {children}
                        </ThemeProvider>
                    </UcThemeContext.Provider>
                }
                {loading &&
                    <Box sx={{ display: 'flex' }}>
                        <CircularProgress />
                    </Box>
                }
            </>
        );
    };